import $ from 'jquery';
import '@fancyapps/fancybox';
$('.investment--js').on('click', function (event) {
	event.preventDefault();
	$.fancybox.open({
		loop: false,
		src: '#investment-modal',
		baseClass: 'investment-fancybox',
		touch: false,
	});
});
